export default "__VITE_ASSET__a0c673cd__"